import Image from "next/image";
type Props = {
    src: string
    alt: string
    title: string
}

const DynamicImage = ({ src, alt, title }: Props) => {
    return (
        <div className="relative w-full h-[400px] overflow-hidden">
            <Image
                src={process.env.IMAGE_URL + src || "/slang-banner.jpg"}
                alt={alt || "هیرونیا"}
                layout="fill"
                objectFit="cover"
                className="w-full h-auto max-h-[400px]"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
        </div>
    );
};

export default DynamicImage;